import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ViewEmployeeVoicePageRoutingModule } from './view-employee-voice-routing.module';

import { ViewEmployeeVoicePage } from './view-employee-voice.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ViewEmployeeVoicePageRoutingModule
  ],
  declarations: [ViewEmployeeVoicePage]
})
export class ViewEmployeeVoicePageModule {}
